import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Typography, Divider, Layout, Image, Alert, Row, Col, Card } from 'antd';
import blogData from '../components/data/blogdata'; // Adjust if needed

const { Title, Paragraph, Text } = Typography;
const { Content } = Layout;

const BlogDetails = () => {
    const { id } = useParams();
    const post = blogData.find((item) => item.id === id);

    if (!post) {
        return (
            <Layout style={{ padding: '40px 20px', maxWidth: 1200, margin: '0 auto' }}>
                <Alert message="Blog post not found" type="error" showIcon />
            </Layout>
        );
    }

    const relatedPosts = blogData.filter((item) => item.id !== id).slice(0, 4); // Limit to 4 related posts

    return (
        <Layout style={{ padding: '40px 20px', maxWidth: 1200, margin: '0 auto' }}>
            <Row gutter={[32, 32]}>
                {/* Main Blog Content */}
                <Col xs={24} md={16}>
                    <Content>
                        <Image
                            src={post.imgUrl}
                            alt={post.title}
                            width="100%"
                            height={400}
                            style={{ objectFit: 'cover', borderRadius: 12 }}
                            preview={false}
                        />

                        <Title level={2} style={{ marginTop: 24 }}>{post.title}</Title>
                        <Text type="secondary">
                            By {post.author} • {post.date} • {post.time}
                        </Text>

                        <Divider />

                        <Paragraph style={{ fontSize: 16, color: '#555' }}>
                            {post.description}
                        </Paragraph>

                        <Divider dashed />

                        <Paragraph italic style={{ fontSize: 16, color: '#888', borderLeft: '4px solid #eee', paddingLeft: 12 }}>
                            “{post.quote}”
                        </Paragraph>

                        <Divider />

                        <Paragraph
                            style={{
                                whiteSpace: 'pre-line',
                                fontSize: 17,
                                lineHeight: '1.9',
                                color: '#444',
                                textAlign: 'justify',
                                marginTop: 24,
                                padding: '0 4px',
                            }}
                        >
                            {post.content}
                        </Paragraph>

                    </Content>
                </Col>

                {/* Sidebar */}
                <Col xs={24} md={8}>
                    <Title level={4} style={{ marginBottom: 16 }}>More Posts</Title>
                    {relatedPosts.map((item) => (
                        <Card
                            key={item.id}
                            hoverable
                            style={{ marginBottom: 20 }}
                            bodyStyle={{ padding: 12 }}
                            cover={
                                <Link to={`/blog/${item.id}`}>
                                    <Image
                                        src={item.imgUrl}
                                        alt={item.title}
                                        height={120}
                                        style={{ objectFit: 'cover', borderRadius: 6 }}
                                        preview={false}
                                    />
                                </Link>
                            }
                        >
                            <Link to={`/blog/${item.id}`}>
                                <Title level={5} style={{ marginBottom: 0 }}>{item.title}</Title>
                            </Link>
                            <Text type="secondary" style={{ fontSize: 12 }}>{item.date}</Text>
                        </Card>
                    ))}
                </Col>
            </Row>
        </Layout>
    );
};

export default BlogDetails;
